import { useTranslations } from "next-intl";
import { useState } from "react";
import { usePathname } from "@lib/i18n/navigation-pages-router";
import MenuListButton from "@components/core/MenuListButton";
import { useDislikeProduct } from "@hooks/use-current-user";
import { deleteProductFromUserList } from "@utils/call-api/userlists-call";

function MenuUserListProductEdit({ product, onActionEnd }) {
  const t = useTranslations("common");

  const pathname = usePathname();
  const dislikeProduct = useDislikeProduct();

  const [processingRemoveFromUserList, setProcessingRemoveFromUserList] = useState(false);
  const [processingDislike, setProcessingDislike] = useState(false);

  async function removeFromUserListAndClose() {
    try {
      setProcessingRemoveFromUserList(true);
      const userListUuid = pathname.split("/").filter(Boolean)[1];

      await deleteProductFromUserList(userListUuid, product.id);
      onActionEnd();
    } catch (err) {
      onActionEnd();
    }
  }

  async function dislikeAndClose() {
    try {
      setProcessingDislike(true);
      await dislikeProduct(product.id);
      onActionEnd();
    } catch (err) {
      onActionEnd();
    }
  }

  return (
    <div className="d-flex flex-column w-100">
      <MenuListButton
        onClick={removeFromUserListAndClose}
        trackingName="RemoveFromUserlistFromOffcanvas"
        loading={processingRemoveFromUserList}
        className="menu-list-button-desktop-rounded-top"
      >
        {t("userlist.remove_from_userlist")}
      </MenuListButton>
      <MenuListButton
        onClick={dislikeAndClose}
        trackingName="RemoveFromWishlistFromOffcanvas"
        loading={processingDislike}
      >
        {t("userlist.remove_from_wishlist")}
      </MenuListButton>
    </div>
  );
}

export default MenuUserListProductEdit;
